"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findSubItems = findSubItems;
exports.buildSections = buildSections;
exports.getActiveHeaderAnchor = getActiveHeaderAnchor;
exports.HeadingIcon = exports.AsideHeading = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function findSubItems(pickedHeadings, index) {
  var h2Indices = pickedHeadings.reduce(function (a, item, i) {
    if (item.level === 2) a.push(i);
    return a;
  }, []);
  var nextH2 = h2Indices[h2Indices.indexOf(index) + 1];
  return pickedHeadings.slice(index, nextH2).filter(function (f) {
    return f.level === 3;
  });
} // splits an array of headings into a nested array


function buildSections(headings) {
  if (!headings) return [];
  var pickedHeadings = headings.filter(function (heading) {
    return heading.level === 2 || heading.level === 3;
  });
  return pickedHeadings.reduce(function (arr, heading, index) {
    if (heading.level === 2) {
      arr.push({
        id: heading.slug,
        value: heading.text,
        children: findSubItems(pickedHeadings, index).map(function (sub) {
          return _objectSpread({
            id: sub.slug,
            value: sub.text
          }, sub.icon && {
            icon: sub.icon
          });
        })
      });
    }

    return arr;
  }, []);
} // finds the active header anchor
// adapted from https://github.com/facebook/docusaurus/blob/2aae77124eaaac3d768547a88f77c4b2402f7dec/packages/docusaurus-theme-classic/src/theme/hooks/useTOCHighlight.ts


function getActiveHeaderAnchor(topOffset) {
  // get all docs-content headers and then convert nodelist to array
  var headersAnchors = Array.prototype.slice.call(document.querySelectorAll('#docs-content h2.anchor, #docs-content h3.anchor')); // if there are no found header anchors, return undefined

  if (!headersAnchors || headersAnchors.length === 0) return undefined;
  var anchorsUnderViewportTop = headersAnchors.filter(function (anchor) {
    var _anchor$getBoundingCl = anchor.getBoundingClientRect(),
        top = _anchor$getBoundingCl.top;

    if (top >= topOffset) return anchor;
  });
  var firstAnchorUnderViewportTop = anchorsUnderViewportTop && anchorsUnderViewportTop.length ? anchorsUnderViewportTop[0] : undefined;
  var lastAnchor = headersAnchors[headersAnchors.length - 1]; // if bottom of page, return last heading as acive

  if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight) {
    return lastAnchor;
  }

  if (firstAnchorUnderViewportTop) {
    // If first anchor in viewport is under a certain threshold, we consider it's not the active anchor.
    // In such case, the active anchor is the previous one (if it exists), that may be above the viewport
    if (firstAnchorUnderViewportTop.getBoundingClientRect().top >= topOffset) {
      var previousAnchor = headersAnchors[headersAnchors.indexOf(firstAnchorUnderViewportTop) - 1];
      return previousAnchor !== null && previousAnchor !== void 0 ? previousAnchor : firstAnchorUnderViewportTop;
    } // If the anchor is at the top of the viewport, we consider it's the first anchor
    else {
        return firstAnchorUnderViewportTop;
      }
  } // no anchor under viewport top
  else {
      return lastAnchor;
    }
}

var AsideHeading = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AsideHeading, _React$PureComponent);

  var _super = _createSuper(AsideHeading);

  function AsideHeading() {
    _classCallCheck(this, AsideHeading);

    return _super.apply(this, arguments);
  }

  _createClass(AsideHeading, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("h2", {
        id: this.props.id,
        className: "unprose txt-m txt-bold mb6"
      }, this.props.children);
    }
  }]);

  return AsideHeading;
}(_react.default.PureComponent);

exports.AsideHeading = AsideHeading;
AsideHeading.propTypes = {
  children: _propTypes.default.node,
  id: _propTypes.default.string
};

var HeadingIcon = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(HeadingIcon, _React$PureComponent2);

  var _super2 = _createSuper(HeadingIcon);

  function HeadingIcon() {
    _classCallCheck(this, HeadingIcon);

    return _super2.apply(this, arguments);
  }

  _createClass(HeadingIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "color-darken75 mr6 w18 h18 bg-gray-faint round-full flex-parent-inline flex-parent--center-main flex-parent--center-cross relative ml-neg12",
        style: {
          top: 3
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: 16,
        name: this.props.name
      }));
    }
  }]);

  return HeadingIcon;
}(_react.default.PureComponent);

exports.HeadingIcon = HeadingIcon;
HeadingIcon.propTypes = {
  name: _propTypes.default.node
};